<div>
  <app-nav-bar>
    <main class="container-main">
      <div class="row d-flex justify-content-between row-header-send">
        <div class="d-flex gap-8">
          <span class="screen-title">Gestão de parceiros</span>
        </div>
      </div>

      <div class="card-filters">
        <div class="header-filter">
          <h5>Cadastro de parceiro</h5>
        </div>

        <div class="content-filter">
          <form [formGroup]="partnerForm">
            <div class="row">
              <!-- Razão Social -->
              <div class="col-12">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Razão social</mat-label>
                  <input
                    formControlName="companyName"
                    matInput
                    type="text"
                    required
                  />
                  <mat-error
                    *ngIf="
                      partnerFormControl.companyName.touched &&
                      partnerFormControl.companyName.errors?.required
                    "
                  >
                    Razão social obrigatória
                  </mat-error>
                  <mat-error
                    *ngIf="
                      partnerFormControl.companyName.touched &&
                      partnerFormControl.companyName.hasError('maxlength')
                    "
                  >
                    Razão social deve ter no máximo 144 caracteres
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="row mt-12">
               <!-- CNPJ -->
               <div class="col-12 col-md-4">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>CNPJ</mat-label>
                  <input
                    formControlName="cnpj"
                    mask="AA.AAA.AAA/AAAA-00"
                    [clearIfNotMatch]="false"
                    uppercase
                    matInput
                    type="text"
                    autocomplete="off"
                    style="text-transform: uppercase"
                    required
                  />
                  <mat-error
                    *ngIf="
                      partnerFormControl.cnpj.touched &&
                      partnerFormControl.cnpj.errors?.required
                    "
                  >
                    CNPJ obrigatório
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- Agência -->
              <div class="col-12 col-md-4">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Agência</mat-label>
                  <input
                    formControlName="agencyNumber"
                    matInput
                    type="text"
                    inputmode="numeric"
                    required
                  />
                  <mat-error
                    *ngIf="
                      partnerFormControl.agencyNumber.touched &&
                      partnerFormControl.agencyNumber.errors?.required
                    "
                  >
                    Agência obrigatória
                  </mat-error>
                  <mat-error
                    *ngIf="
                      partnerFormControl.agencyNumber.touched &&
                      partnerFormControl.agencyNumber.hasError('pattern')
                    "
                  >
                    Apenas números são permitidos
                  </mat-error>
                  <mat-error
                    *ngIf="
                      partnerFormControl.agencyNumber.touched &&
                      partnerFormControl.agencyNumber.hasError('maxlength')
                    "
                  >
                    Agência deve ter no máximo 10 caracteres
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- Spread -->
              <div class="col-12 col-md-4">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Spread</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="spread"
                    required
                    currencyMask
                    [options]="{
                      prefix: '',
                      thousands: '.',
                      decimal: ',',
                      suffix: ' %',
                      align: 'left',
                      allowNegative: false
                    }"
                  />
                  <mat-error
                    *ngIf="
                      partnerFormControl.spread.touched &&
                      partnerFormControl.spread.errors?.required
                    "
                  >
                    Spread obrigatório
                  </mat-error>
                  <mat-error
                    *ngIf="
                      partnerFormControl.spread.touched &&
                      (partnerFormControl.spread.hasError('min') ||
                        partnerFormControl.spread.hasError('max'))
                    "
                  >
                    Spread deve estar entre 0% e 100%
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="row mt-4">
              <!-- Tarifa -->
              <div class="col-12 col-md-4">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Tarifa</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="tariff"
                    required
                    currencyMask
                    [options]="{
                      prefix: 'R$ ',
                      thousands: '.',
                      decimal: ',',
                      align: 'left',
                      allowNegative: false
                    }"
                  />
                  <mat-error
                    *ngIf="
                      partnerFormControl.tariff.touched &&
                      partnerFormControl.tariff.errors?.required
                    "
                  >
                    Tarifa obrigatória
                  </mat-error>
                  <mat-error
                    *ngIf="
                      partnerFormControl.tariff.touched &&
                      partnerFormControl.tariff.hasError('min')
                    "
                  >
                    Tarifa não pode ser menor que zero
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- Spread OZ -->
              <div class="col-12 col-md-4">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Spread OZ</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="institutionalSpread"
                    required
                    currencyMask
                    [options]="{
                      prefix: '',
                      thousands: '.',
                      decimal: ',',
                      suffix: ' %',
                      precision: 3,
                      align: 'left',
                      allowNegative: false
                    }"
                  />
                  <mat-error
                    *ngIf="
                      partnerFormControl.institutionalSpread.touched &&
                      partnerFormControl.institutionalSpread.errors?.required
                    "
                  >
                    Spread OZ obrigatório
                  </mat-error>
                  <mat-error
                    *ngIf="
                      partnerFormControl.institutionalSpread.touched &&
                      (partnerFormControl.institutionalSpread.hasError('min') ||
                        partnerFormControl.institutionalSpread.hasError('max'))
                    "
                  >
                    Spread OZ deve estar entre 0% e 100%
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- Spread bancário -->
              <div class="col-12 col-md-4">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Spread bancário</mat-label>
                  <mat-select formControlName="spreadBanking" required>
                    <mat-option [value]="true">Ativado</mat-option>
                    <mat-option [value]="false">Desativado</mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="
                      partnerFormControl.spreadBanking.touched &&
                      partnerFormControl.spreadBanking.hasError('required')
                    "
                  >
                    Spread bancário obrigatório
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <!-- Botões -->
            <div class="buttons-filter">
              <button
                type="button"
                [style.width]="'134px'"
                class="btn-outline-dark btn"
                (click)="resetForm()"
              >
                Limpar
              </button>

              <button
                class="btn btn-dark-primary-blue"
                type="button"
                [disabled]="partnerForm.invalid || loading"
                (click)="sendPartner()"
              >
                Salvar
                <span
                  class="spinner-border spinner-border-sm"
                  *ngIf="loading"
                ></span>
              </button>
            </div>
          </form>
        </div>
      </div>
      <ng-container *ngIf="havePartners">
        <div class="box-order">
          <div class="padding-bottom-32 padding-top-10 header-box">
            <span class="mb-0"> Parceiros cadastrados </span>

            <div class="search-container">
              <input
                type="text"
                class="search-input"
                [formControl]="searchControl"
                placeholder="Pesquisar por razão social, CNPJ, agência..."
                (keyup.enter)="onFilter()"
              />
              <img
                src="assets/image/search.svg"
                class="search-icon"
                (click)="onFilter()"
              />
            </div>
          </div>

          <div class="padding-content">
            <app-table-partners-admin
              *ngIf="showTables"
              [displayedColumns]="tableDisplayedColumns"
              [data]="partners"
              [pageNumber]="pageNumber"
              [pageSize]="pageSize"
            ></app-table-partners-admin>
          </div>
        </div>
      </ng-container>

      <div
        *ngIf="loadingTable"
        class="accordion-item painel painel-accordion error-orders"
      >
        <div class="img-error-orders">
          <span class="spinner-border text-primary"></span>
        </div>
      </div>

      <div
        *ngIf="showPartnersError"
        class="accordion-item painel painel-accordion error-orders"
      >
        <div class="img-error-orders">
          <img
            width="258"
            height="160"
            src="assets/image/error-order-icon.svg"
          />
        </div>

        <p id="txt-error-orders-register">Infelizmente encontramos um erro!</p>
        <p id="txt-error-order">
          Você pode aguardar uns instantes e tentar recarregar a <br />página
          mais uma vez.
        </p>

        <div class="btn-send-content">
          <button
            (click)="reloadPage()"
            class="btn btn-block mt-0 ml-3 btn-dark-primary-blue"
            type="button"
          >
            Tentar Novamente
          </button>
        </div>
      </div>
    </main>
  </app-nav-bar>
</div>
